<mat-nav-list class="text-center">
  <a mat-list-item routerLink="/myspace/myjourney" (click)="dismiss()">
    <span mat-line>{{ 'MySpace.MyJourney' | translate }}</span>
  </a>
  <a mat-list-item routerLink="/myspace/my-models" (click)="dismiss()">
    <span mat-line>{{ 'MySpace.MyModels' | translate }}</span>
  </a>
  <a mat-list-item routerLink="/myspace/requests" (click)="dismiss()">
    <span mat-line>{{ 'MySpace.UserRequests' | translate }}</span>
  </a>
  <a mat-list-item routerLink="/myspace/profile" (click)="dismiss()">
    <span mat-line>{{ 'MySpace.Profile' | translate }}</span>
  </a>

  @if (isAdmin()) {
    <a mat-list-item routerLink="/myspace/user-management" (click)="dismiss()">
      <span mat-line>{{ 'Global.ManageUsers' | translate }}</span>
    </a>
  }
  @if (isAdmin()) {
    <a mat-list-item routerLink="/myspace/credit" (click)="dismiss()">
      <span mat-line>{{ 'MySpace.Billing' | translate }}</span>
    </a>
  }

  @if (isAdmin()) {
    <a mat-list-item routerLink="/myspace/ai-section" (click)="dismiss()">
      <span mat-line>{{ 'MySpace.AISection' | translate }}</span>
    </a>
  }
  @if (isAdmin() && enableAppCustomization) {
    <a mat-list-item [routerLink]="getMySpaceCustomizerTab()" (click)="dismiss()">
      <span mat-line>{{ 'MySpace.PersonalizeApp' | translate }}</span>
    </a>
  }
  <!-- <a *ngIf="isAdmin()" mat-list-item routerLink="/myspace/api-usage" (click)="dismiss()">
  <span mat-line>{{'MySpace.APIUsage' | translate}}</span>
</a> -->

  <!-- <a mat-list-item routerLink="/myspace/account" (click)="dismiss()">
<span mat-line>{{'MySpace.Account' | translate}}</span>
</a> -->
</mat-nav-list>
